module.exports = __webpack_public_path__ + "media/images/blog/sample-cover-30756f88a06a4408cf2232ccef247d22.jpg";